import { Link } from "react-router-dom";

const HeroSection = ({
  title,
  subtitle,
  description,
  backgroundImage,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
}) => {
  return (
    <section
      className="relative min-h-[50vh] sm:min-h-[30vh] flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* Background Overlay */}
      <div className="absolute inset-0 bg-foreground/70" />
      
      {/* Content */}
      <div className="relative z-10 container-custom text-center px-4 py-20">
        {/* Subtitle */}
        {subtitle && (
          <p className="text-secondary font-montserrat font-semibold text-3xl sm:text-lg md:text-xl mb-4 animate-fade-in">
            {subtitle}
          </p>
        )}
        
        {/* Main Title */}
        <h1 className="font-montserrat text-2xl sm:text-4xl md:text-5xl lg:text-5xl font-bold text-background mb-6 animate-slide-up">
          {title}
        </h1>
        
        {/* Description */}
        <p className="text-background/90 text-2xl sm:text-lg md:text-xl max-w-3xl mx-auto mb-8 animate-slide-up stagger-2">
          {description}
        </p>
        
        {/* Action Buttons */}
        {(primaryButtonText || secondaryButtonText) && (
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-slide-up stagger-3">
            {primaryButtonText && primaryButtonLink && (
              <Link 
                to={primaryButtonLink} 
                className="btn-secondary text-sm sm:text-base"
              >
                {primaryButtonText}
              </Link>
            )}
            {secondaryButtonText && secondaryButtonLink && (
              <Link 
                to={secondaryButtonLink} 
                className="btn-outline border-background text-background hover:bg-background hover:text-foreground text-sm sm:text-base"
              >
                {secondaryButtonText}
              </Link>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroSection;